import React, { useEffect, useState } from 'react';
import {Menu, Drafts, Inbox, CheckCircleRounded, Description, Autorenew, CheckCircleOutlineRounded} from '@material-ui/icons/';
import { AppBar, Card, Chip, Container, Divider, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Paper, Toolbar, Typography } from '@material-ui/core';
//COMPONENTES
import DialogLoadingMessage from 'components/LoadingMessage/index'
import {useStyles} from './style';
import ApiServices from 'services/ApiServices';
import { showMessagePersonalizedPosition } from 'services/SweetAlert';

export default function  FiltrosParaGenerarConstanciaDeActa (props) {
    const classes = useStyles();
    const [datosEstadisticosNacional, setDatosEstadisticosNacional] = useState({nacional: props.datosEstadisticosNacional.nacional, generados: props.datosEstadisticosNacional.generados, pendientes: props.datosEstadisticosNacional.pendientes});
    const [loadingMessage, setLoadingMessage] = useState({open: false, title: ''});

    const FuncionObtenerEstadisticasDelegacion = async () => {
        setLoadingMessage({loading: true, title:'Actualizando datos de informes ...'})                
        let saveData = {
            coddep: 0,
            tipo: 0,
        };
        try {
            let response = await ApiServices.generarInformeCierre.estadisticas(saveData)
            if(response.error!==null){
                showMessagePersonalizedPosition('error','¡Advertencia!', response.error,'center')
            }
            else{
                setDatosEstadisticosNacional({nacional: response.data.listadoNacional, generados: response.data.generado, pendientes: response.data.pendiente})
            }
        } catch (exception) {
            showMessagePersonalizedPosition('error', '¡Advertencia! ',"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
        }  
        setLoadingMessage({loading: false, title:''})
    };

    return (
        <div className={classes.root}>
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            <div className={classes.contenedor}>
                <Card className={classes.contenedorCard}>
                    <div className={classes.cardContent}>
                        <Description className={classes.iconGeneradas}/>
                        <Typography className={classes.typographyTitulo} variant="subtitle2" gutterBottom>Generadas</Typography>
                        <Typography className={classes.typographyTotales} variant="body2" gutterBottom>{datosEstadisticosNacional.generados}</Typography>
                    </div>
                </Card>
                <IconButton className={classes.avatar} onClick={FuncionObtenerEstadisticasDelegacion}>                
                    <Autorenew />
                </IconButton >
                <Card className={classes.contenedorCard}>
                    <div className={classes.cardContent}>
                        <Description className={classes.iconPendientes}/>
                        <Typography className={classes.typographyTitulo} variant="subtitle2" gutterBottom>Pendientes</Typography>
                        <Typography className={classes.typographyTotales} variant="body2" gutterBottom>{datosEstadisticosNacional.pendientes}</Typography>
                    </div>
                </Card>
            </div>
            <Grid container spacing={3} className={classes.gridContainer}>
                {
                    datosEstadisticosNacional.nacional.map((label, index) => (
                        <Grid item sm={2}>
                            <Paper className={classes.paper}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} className={classes.textoAlinear}>
                                        <Typography className={classes.description} variant="subtitle1" gutterBottom>{label.departamento}</Typography>
                                    </Grid>
                                    {
                                        // console.log('label', label.coddep)
                                        (label.pendiente === '0') ? (
                                                <Grid item xs={12} className={classes.textoAlinear}>
                                                    <CheckCircleOutlineRounded className={classes.iconSuccess}/>
                                                </Grid>
                                        ) : (
                                            <>
                                                <Grid item xs={6} className={classes.textoAlinear}>
                                                    <Typography className={classes.description} variant="subtitle1" gutterBottom>{'Generadas'}</Typography>
                                                    <Chip label={label.generado} variant="outlined" className={classes.success}/>
                                                </Grid>
                                                <Grid item xs={6} className={classes.textoAlinear}>
                                                    <Typography className={classes.description} variant="subtitle1" gutterBottom>{'Pendientes'}</Typography>
                                                    <Chip label={label.pendiente} variant="outlined" className={classes.error}/>
                                                </Grid>
                                            </>                                    
                                    )}
                                </Grid>
                            </Paper>
                        </Grid>
                    ))                    
                }
            </Grid>
      </div>
    );   
}